import qs from 'qs';
import { memo, useCallback } from 'react';
import { navigationRef, StackNavigationProp, useNavigation } from '@betty/navigation';
import { logError } from '@betty/toolkit/logging';
import { DepositInteracProps } from './DepositInterac.types';
import {
  handleRestrictedFunctionality,
  retrieveTransactionIdFromError,
} from '../../utils/payments';
import { DepositNavigatorParamsList } from '../../navigators/DepositNavigator/DepositNavigator.types';
import { PaymentHandler } from '../../components/PaymentInterac/PaymentInterac.types';
import PaymentLaunchService from '../../services/PaymentLaunchService/PaymentLaunchService';
import PaymentInterac from '../../components/PaymentInterac/PaymentInterac';
import { Platform } from 'react-native';

function DepositInterac({ amount, close }: DepositInteracProps) {
  const navigation =
    useNavigation<StackNavigationProp<DepositNavigatorParamsList>>();

  const onPayment = useCallback<PaymentHandler>(
    async (data) => {
      try {
        if (Platform.OS === 'web') {
          const queryString = qs.stringify(data);

          window.open(
            `${window.location.origin}/interac-redirect?${queryString}`,
            '_blank',
          );

          window.addEventListener('message', (event) => {
            if (event.origin === window.location.origin) {
              try {
                const { transactionId } = JSON.parse(event.data);

                close();

                // We need to use navigationRef because the this is inside a bottom sheet
                // and the PaymentStatusScreen is mounted inside of a modal
                navigationRef.navigate('PaymentStatusScreen', {
                  transactionId: `${transactionId}`,
                });
              } catch (error) {
                logError('Interac redirect message parsing failure.', error);
              }
            }
          });

          return;
        }

        const { transactionId, url } =
          await PaymentLaunchService.depositInterac({ data });

        close();

        navigation.navigate('PaymentStatusScreen', {
          transactionId: `${transactionId}`,
        });
        navigation.navigate('DepositInteracURLScreen', { url });
      } catch (error) {
        logError('Launch Interac deposit request failure.', error);

        close();

        const transactionId = retrieveTransactionIdFromError(error);

        if (transactionId !== undefined) {
          navigation.navigate('PaymentStatusScreen', {
            transactionId: `${transactionId}`,
          });

          return;
        }

        handleRestrictedFunctionality(error);
      }
    },
    [navigation, close],
  );

  return (
    <PaymentInterac
      amount={amount}
      onPayment={onPayment}
      buttonKey="interacDeposit"
      paddingTop="space-400"
    />
  );
}

export default memo(DepositInterac);
